<template>
    <div class="flex justify-center items-center min-h-[50vh] px-4 py-20 lg:px-20">
        <div class="flex flex-col items-center mb-6 shadow-2xl rounded-lg overflow-hidden">
            <Image :src="dashboardSplash"
                   style="opacity:0.6" />
        </div>
    </div>
</template>

<script setup>
import { setStoreValue } from "@pages/Helper/utils.js";
import Image from '@helper/Image.vue'
import { dashboardSplash } from '@helper/constants.js'

const props = defineProps({
    systemName: String,
    currentModule: String,
    systemData: Object,
});

setStoreValue("currentModule", props.currentModule);
</script>

<style scoped></style>
